<template>
    <nav :class="classNames">
        <ul class="sidebar-menu">
            <li v-for="(item, i) in items" :key="i">
                <template v-if="!!item.subitems">
                    <a
                        v-b-toggle="`collase-${i}-${item.url}`"
                        :class="`${item.className} has-subitems`"
                        href="javascript:void(0);"
                        >{{ item.text }}</a
                    >
                    <b-collapse
                        :id="`collase-${i}-${item.url}`"
                        :visible="isVisible(item.url)"
                    >
                        <ul class="sidebar-submenu">
                            <li v-for="(subitem, j) in item.subitems" :key="j">
                                <router-link :to="{ name: subitem.url }"
                                    >{{ subitem.text }}
                                </router-link>
                            </li>
                        </ul>
                    </b-collapse>
                </template>
                <router-link
                    v-else
                    :to="{ name: item.url }"
                    :class="item.className"
                    >{{ item.text }}
                </router-link>
            </li>
        </ul>
        <div class="sidebar-footer">
            <ul v-if="footerItems.length > 0" class="sidebar-menu">
                <li v-for="(item, i) in footerItems" :key="i">
                    <router-link
                        :to="{ name: item.url }"
                        :class="item.className"
                        >{{ item.text }}
                    </router-link>
                </li>
            </ul>
            <div class="aneel-logo">
                <img :src="aneelLogo" alt="logo aneel" />
            </div>
            <div class="credits">
                <span v-if="isSimworxLogo">Desenvolvido por</span>
                <div>
                    <img :src="footerImg" alt="logo usina" />
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import { mapState } from "vuex";

import FOZ_CHAPECO_LOGO from "@/assets/images/logo-foz-chapeco.png";
import JULHO_14_LOGO from "@/assets/images/logo-ceran.png";
import CAMPOS_NOVOS_LOGO from "@/assets/images/logo-enercan.png";
import SIMWORX_LOGO from "@/assets/images/logo-simworx.png";
import ANEEL_LOGO from "@/assets/images/logo-aneel-sidebar.png";

function validator(value) {
    if (!Array.isArray(value)) {
        return false;
    }
    for (const item of value) {
        if (!("url" in item) || !("className" in item) || !("text" in item)) {
            return false;
        }
    }
    return true;
}

export default {
    name: "SimbarSidebar",
    props: {
        items: {
            type: Array,
            required: true,
            validator
        },
        footerItems: {
            type: Array,
            validator,
            default() {
                return [];
            }
        }
    },
    computed: {
        ...mapState("dashboard", ["sidebar"]),
        classNames() {
            return {
                sidebar: true,
                open: this.sidebar.open
            };
        },
        footerImg() {
            if (this.$route.name.includes("foz_chapeco")) {
                return FOZ_CHAPECO_LOGO;
            }
            if (this.$route.name.includes("campos_novos")) {
                return CAMPOS_NOVOS_LOGO;
            }
            if (this.$route.name.includes("julho_14")) {
                return JULHO_14_LOGO;
            }

            return SIMWORX_LOGO;
        },
        isSimworxLogo() {
            return !(
                this.$route.name.includes("foz_chapeco") ||
                this.$route.name.includes("campos_novos") ||
                this.$route.name.includes("julho_14")
            );
        },
        aneelLogo() {
            return ANEEL_LOGO;
        }
    },
    methods: {
        isVisible(url) {
            return this.$route.name.indexOf(url) >= 0;
        }
    }
};
</script>

<style lang="scss">
.sidebar {
    width: $sidebar-width;
    max-width: $sidebar-width;
    min-height: calc(100% - #{$navbar-height});
    display: flex;
    position: fixed;
    flex-direction: column;
    z-index: 12;
    background-color: lighten($dark, 5%);
}

@include media-breakpoint-down(sm) {
    .sidebar {
        transition: transform 0.3s ease-in-out;
        transform: translateX(-100%);
        min-height: calc(100% - #{$navbar-height});
    }
    .sidebar.open {
        transform: translateX(0);
    }

    .bg-open-sidebar {
        transition: background 0.3s ease-in-out;

        &.open {
            position: fixed;
            top: 0;
            bottom: 0;
            right: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.2);
            z-index: 11;
        }
    }
}

.sidebar-menu {
    flex: 1;
    padding: 0;
    list-style: none;
    margin-bottom: 0;

    li a {
        font-weight: 500;
        padding: 15px;
        display: flex;
        align-items: center;
        text-decoration: none;
        transition: all 0.5s ease;
        color: $gray-400;
        font-size: 0.875rem;
        position: relative;

        @include hover-focus() {
            color: #ffffff;
            background-color: rgba(255, 255, 255, 0.1);
        }

        &.has-subitems {
            background-color: $primary;
            color: #ffffff;

            &::after {
                font-style: normal;
                font-variant: normal;
                text-rendering: auto;
                -webkit-font-smoothing: antialiased;
                font-family: "Font Awesome 5 Free";
                font-size: 1rem;
                content: "\f107";
                font-weight: 900;
                position: absolute;
                right: 0;
                margin-right: 10px;
                transition: transform 0.35s ease;
            }

            &[aria-expanded="false"] {
                color: rgba(255, 255, 255, 0.9);
                background: inherit;

                &::after {
                    transform: rotate(-90deg);
                }
            }
        }

        &.router-link-active {
            background-color: $primary;
            color: #ffffff;
        }

        &::before {
            font-style: normal;
            font-variant: normal;
            text-rendering: auto;
            -webkit-font-smoothing: antialiased;
            font-family: "Font Awesome 5 Free";
            font-size: 1rem;
            font-weight: 900;
            margin-right: 15px;
            text-align: center;
            width: $fa-fw-width;
        }

        &.prisms::before {
            content: fa-content($fa-var-wifi);
            @include fa-icon-rotate(90deg, 1);
        }

        &.sensors::before {
            content: fa-content($fa-var-signal);
        }

        &.simulator::before {
            content: "\f1ec";
        }

        &.alerts::before {
            content: fa-content($fa-var-bullhorn);
        }

        &.reservoir::before {
            content: fa-content($fa-var-water);
        }

        &.visualization::before {
            content: fa-content($fa-var-cube);
        }

        &.triaxial-joints::before {
            content: fa-content($fa-var-ruler-combined);
        }
    }
}

.sidebar-submenu {
    list-style: none;
    padding: 0;

    li a {
        padding: 15px 15px 15px 45px;

        &.router-link-active {
            color: #ffffff;
            background-color: rgba(255, 255, 255, 0.1);
        }
    }
}

.sidebar-footer {
    flex: 0 1 auto;
    width: 100%;

    .aneel-logo {
        background: #ffffff;
        border-right: 1px solid #eeeeee;
        border-bottom: 1px solid #eeeeee;
        padding: 10px 5px;
        text-align: center;
        img {
            display: inline-block;
            max-width: 100%;
            height: 50px;
        }
    }

    .credits {
        border-right: 1px solid #eeeeee;
        background: #ffffff;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: center;
        padding: 10px 5px;
        font-size: 0.875rem;

        > span {
            margin-right: 0.75rem;
        }

        img {
            display: block;
            max-width: 100%;
            height: 40px;
        }
    }
}
</style>
